import { QueryClient } from '@tanstack/react-query';
import { ApiError } from '@/lib/api/client';

export const queryKeys = {
  me: ['me'] as const,
  board: (scope: string) => ['board', scope] as const,
  tasks: (params: Record<string, unknown>) => ['tasks', params] as const,
  task: (id: string) => ['task', id] as const,
  taskEvents: (id: string) => ['task', id, 'events'] as const,
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      /**
       * Both off deliberately. Once the realtime socket is live they are redundant,
       * and they double the request load on every tab switch. Resync is driven by the
       * socket's own state machine instead — one invalidation on gap-close.
       */
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry(failureCount, error) {
        // Never retry a refusal: the answer will not change, and retrying a 401 or 403
        // turns one rejection screen into four identical failed requests.
        if (error instanceof ApiError && error.status >= 400 && error.status < 500) return false;
        return failureCount < 2;
      },
    },
  },
});
